var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtcd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60637 10.8878C12.4639 10.0063 11.4441 7.04362 9.60637 6.93112C10.0732 6.93112 10.4546 5.59406 10.4546 3.9375C14.9411 4.25644 17.0488 11.6499 10.3196 13.9629C10.3629 13.3628 10.1171 11.6876 9.60694 10.8878H9.60637ZM3.375 10.0125V6.93731H3.38063C5.00344 6.93113 6.31237 5.58731 6.30675 3.94369H9.43425C9.43481 7.29956 6.72469 10.0125 3.375 10.0125ZM7.47394 9.45562C9.33019 10.9811 9.43481 13.5501 9.43481 14.0625H6.30675C6.30675 12.3626 5.20031 10.9873 3.83006 10.9873C6.15319 10.6127 6.62625 10.2189 7.47394 9.45619V9.45562Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtcd);
export default __webpack_public_path__ + "static/media/btcd.4d7f0baea6ed79d9362787d524f9afe3.svg";
export { ForwardRef as ReactComponent };